import React from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import './measurement-item.scss';

type MeasurementItemProps = {
  text: string;
  value: string | React.ReactNode;
  symbolIcon: string;
  iconFontSize?: number;
  subText?: string;
  subValue?: string;
  valueIcon?: React.ReactNode;
  redirectPathname?: string;
};

export const MeasurementItemCommon: React.FC<MeasurementItemProps> = ({
  text,
  value,
  iconFontSize = 20,
  symbolIcon,
  subText,
  subValue,
  valueIcon,
  redirectPathname,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={classNames('measurement-item', { clickable: !!redirectPathname })}
      {...(redirectPathname && { onClick: () => navigate(redirectPathname) })}
    >
      <span className="measurement-item__unit-icon" style={{ fontSize: iconFontSize }}>
        {symbolIcon}
      </span>
      <span className="measurement-item__name">
        <span>{text}</span>
        {subText && <span className="subname">{subText}</span>}
      </span>
      <div className="measurement-item__value-wrapper">
        <span className="measurement-item__value">
          {valueIcon ? valueIcon : null}
          {value}
        </span>
        {subValue && <span className="measurement-sub-value">{subValue}</span>}
      </div>
    </div>
  );
};
